import {FilterType} from '/enum/filterType.enum';

import {RANK_DATA} from '../constants/rankData.constant';

export const buildDefaultRankItems = (
  optionSelected: (id: string, type: FilterType) => void,
) => {
  return RANK_DATA.map(item => ({
    ...item,
    selected: false,
    defaultVal: false,
    onPress: () => optionSelected(item.id, FilterType.RANK),
  }));
};
